import { render } from "./CustomerEvents.vue?vue&type=template&id=79a14e8a"
import script from "./CustomerEvents.vue?vue&type=script&lang=js"
export * from "./CustomerEvents.vue?vue&type=script&lang=js"

import "./CustomerEvents.vue?vue&type=style&index=0&id=79a14e8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__